import React from "react";
import NavData from '../../data/Navigation';
import { Link } from "react-router-dom";
import classes from './MobileNavBar.module.css';

const MobileNavBar = () => {
    return (
        <nav className={classes.navBar}>
            <ul>
                {NavData.map((navItem) => (
                    <Link
                        key={navItem.title}
                        to={navItem.path}
                        className={classes.link}
                    >
                        <li>
                            <span className={classes.icon}>{navItem.icon}</span>
                        </li>
                    </Link>
                ))}
            </ul>
        </nav>
    )
}

export default MobileNavBar;
